import moment from 'moment'
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-flatpickr'
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { getTeacherLessonPlan } from 'store/ClassWork/Actions';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CreateLessonPlanModal from './CreateLessonPlanModal';
import { toast } from 'react-toastify';

const ClassWorkTeacher = () => {
  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState(new Date())

  const { lessonPlanList, Loading, successMsg, errors, isLessonPlanCreated } = useSelector(state => state.ClassWorkReducer);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isLessonEdit, setIsLessonEdit] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState({
    classdiv_id: "",
    subject_id: "",
    lesson_name: "",
    topic: "",
    no_of_req_periods: "",
    planned_date_from: "",
    planned_date_to: "",
    completion_date: "",
    published: 0,
    published_date: "",
    published_by: "",
    files: "",
  })



  const ShowThumbnail = ({ lessonPlan }) => {
    const getFileExtension = url => {
      if (url && url !== "null" && url !== " ") {
        const ext = url.split(".").pop()
        let murl = ""

        if (url.includes("https://s3.amazonaws.com/topschool-attachments")) {
          murl = url.replace(
            "https://s3.amazonaws.com/topschool-attachments",
            "https://files.prisms.in"
          )
        } else {
          murl = url
        }

        if (ext.toLowerCase() === "pdf") {
          return (
            <div className="text-center">
              <i
                className="mdi mdi-file-pdf text-danger"
                style={{ fontSize: "40px" }}
              ></i>
            </div>
          )
        } else if (ext.toLowerCase() === "docx") {
          return (
            <div className="text-center">
              <i
                className="mdi mdi-file-document fs-1 text-primary"
                style={{ fontSize: "40px" }}
              ></i>
            </div>
          )
        } else if (
          ext.toLowerCase() === "jpeg" ||
          ext.toLowerCase() === "png" ||
          ext.toLowerCase() === "jpg"
        ) {
          return (
            <div className="">
              {url ? (
                <img
                  src={murl}
                  width={"100%"}
                  alt="thumbnail"
                  className="rounded-3"
                />
              ) : (
                <img src="" alt="" style={{ display: "none" }} />
              )}
            </div>
          )
        } else if (
          ext.toLowerCase() === "csv" ||
          ext.toLowerCase() === "xlsx"
        ) {
          return (
            <div className="text-center">
              <i
                className="mdi mdi-file-excel text-primary"
                style={{ fontSize: "40px" }}
              ></i>
            </div>
          )
        } else {
          return (
            <div className="text-center">
              <i className="mdi mdi-file" style={{ fontSize: "40px" }}></i>
            </div>
          )
        }
      }
    }

    return (
      <div className="d-flex justify-content p-0">
        {lessonPlan.file_url ? (
          <div className="p-1 w-100">
            <Link
              to={"/media-preview"}
              state={{
                fileurl: lessonPlan.file_url,
              }}
            >
              {getFileExtension(
                lessonPlan?.file_url
              )}
            </Link>
          </div>
        ) : null}

      </div>
    )
  }

  useEffect(() => {
    if (successMsg) {
      toast.success(successMsg)
    }
  }, [successMsg])

  useEffect(() => {
    if (errors) {
      toast.error(errors)
    }
  }, [errors])


  useEffect(() => {
    dispatch(getTeacherLessonPlan())
  }, [])

  useEffect(() => {
    if (isLessonPlanCreated) {
      dispatch(getTeacherLessonPlan())
    }
  }, [isLessonPlanCreated])



  return (
    <div className='page-content'>
      <div className='d-flex justify-content-between align-items-center py-2 px-1 rounded-2 shadow-sm bg-primary text-white'>
        <div className='fw-semibold fs-5'>
          Class Work
        </div>

        <div>
          <Button
            color='success'
            onClick={() => {
              setIsLessonEdit(false)
              setIsShowModal(true)
            }}>New Lesson</Button>
        </div>
        {/* <div>

                    <FlatPickr
                        className="form-control"
                        name="joiningDate"
                        placeholder="Select time"
                        options={{
                            dateFormat: "d M, Y"
                        }}
                        value={selectedDate}
                        onChange={([date]) => setSelectedDate(date)}
                    />

                </div> */}
      </div>


      <Row className='mt-3 gy-3'>
        {lessonPlanList.map((data, index) => (
          <Col xs={12} sm={6} md={6} lg={3} key={index}>
            <Card className='h-100 shadow-sm'>
              <CardHeader tag="h5" className="d-flex justify-content-between bg-primary text-white text-center">
                <p className='mb-0'>{data.lesson_name}</p>

                {/* <i className="mdi mdi-dots-vertical" style={{ cursor: 'pointer' }}></i> */}
              </CardHeader>
              <CardBody>
                <div className="mb-2">
                  <p className="fw-semibold text-muted mb-1">Topics</p>
                  <p className="ps-2">{data.topic}</p>
                </div>

                <div className="mb-2">
                  <p className="fw-semibold text-muted mb-1">No. of Periods</p>
                  <p className="ps-2">{data.no_of_req_periods}</p>
                </div>

                <div className="row mb-2">
                  <div className="col">
                    <p className="fw-semibold text-muted mb-1">Planned From</p>
                    <p className="ps-2">{data.planned_date_from && moment(data.planned_date_from).format("DD/MM/YYYY")}</p>
                  </div>
                  <div className="col">
                    <p className="fw-semibold text-muted mb-1">Planned To</p>
                    <p className="ps-2">{data.planned_date_to && moment(data.planned_date_to).format("DD/MM/YYYY")}</p>
                  </div>
                </div>

                <div>
                  <p className="fw-semibold text-muted mb-1">Completion Date</p>
                  <p className="ps-2">{data.completion_date && moment(data.completion_date).format("DD/MM/YYYY")}</p>
                </div>
                {data.published == 1 ? <div>
                  <p className="fw-semibold text-muted mb-1">Published By</p>
                  <p className="ps-2">{data.published_by_name}</p>
                </div> : null}

                <ShowThumbnail lessonPlan={data} />
              </CardBody>
              <CardFooter
                className={`text-center fw-semibold ${data.published == 1 ? 'bg-primary text-white' : 'bg-danger text-white'}`}
                style={{
                  cursor: "pointer"
                }}
                onClick={() => {
                  if (data.published == 0) {
                    setIsLessonEdit(true)
                    setIsShowModal(true)
                    setSelectedLesson(data)
                  }
                }}>
                {data.published == 1 ? "Published" : "Not Published"}
              </CardFooter>
            </Card>
          </Col>
        ))}



      </Row>
      <CreateLessonPlanModal
        isShowModal={isShowModal}
        setIsShowModal={setIsShowModal}
        isEdit={isLessonEdit}
        setEdit={setIsLessonEdit}
        selectedLesson={selectedLesson} />
    </div>
  )
}

export default ClassWorkTeacher